import { render, staticRenderFns } from "./AddPersonCourseDialog.vue?vue&type=template&id=23101564&"
import script from "./AddPersonCourseDialog.vue?vue&type=script&lang=js&"
export * from "./AddPersonCourseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports